import {DataFetcher} from '@aboutyou/data-fetcher';
import {ProminentBannerSection as ProminentBannerSectionType} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import React from 'react';
import {useCanShowCouponsMinimal} from '../../../features/Coupons/useCanShowCoupons';
import {useProminentBannerSection} from '../ProductInformationBox/MiniArticleDetail/useGetMinimalProductBulkSection';
import {
  ProminentBannerSectionView,
  ProminentBannerSectionViewProps,
} from './ProminentBannerSectionView';

export const ProminentBannerSectionMinimal = (
  props: Omit<
    ProminentBannerSectionViewProps,
    'isDoneFetching' | 'isInMiniADPDialog'
  > & {productId: number} & {ref?: React.Ref<HTMLElement>},
) => {
  const {ref} = props;
  return (
    <DataFetcher
      request={useProminentBannerSection(props.productId)}
      Error={null}
      viewProps={{...props, ref}}
      View={ProminentBannerSectionMinimalView}
    />
  );
};

const ProminentBannerSectionMinimalView: React.FC<
  ProminentBannerSectionType &
    Omit<ProminentBannerSectionViewProps, 'isInMiniADPDialog'> & {
      productId: number;
    }
> = props => {
  const canShowCouponsMinimal = useCanShowCouponsMinimal(props.productId);

  if (props.type?.$case === 'couponSlider' && !canShowCouponsMinimal) {
    return null;
  }

  return <ProminentBannerSectionView {...props} isInMiniADPDialog />;
};
